@if (isEditing()) {
  <div class="edit-wrapper" (click)="$event.stopPropagation()">
    @if (multiline()) {
      <textarea
        #inputRef
        class="edit-input"
        [placeholder]="placeholder()"
        [value]="draft()"
        (input)="onInput($event)"
        (keydown.escape)="$event.stopPropagation(); cancelEdit()"
        rows="2"
      ></textarea>
    } @else {
      <input
        #inputRef
        type="text"
        class="edit-input"
        [placeholder]="placeholder()"
        [value]="draft()"
        (input)="onInput($event)"
        (keydown.escape)="$event.stopPropagation(); cancelEdit()"
        (keydown.enter)="$event.stopPropagation(); submit()"
      />
    }
    <div class="edit-actions tiny-icon-button-wrapper">
      <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'Submit'"
        matTooltip="Submit"
        (click)="submit()"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'Cancel'"
        matTooltip="Discard changes"
        (click)="cancelEdit()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
} @else {
  <div class="display-wrapper">
    @if (isEmpty()) {
      <span class="empty-symbol">{{ emptySymbol() }}</span>
    } @else {
      <span class="value" [matTooltip]="isTrimmed() ? value() : ''">{{ displayValue() }}</span>
    }
    @if (editable()) {
      <span class="tiny-icon-button-wrapper edit-button">
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="'Edit'"
          matTooltip="Edit"
          (click)="$event.stopPropagation(); startEdit()"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </span>
    }
  </div>
}
